module.exports = __webpack_public_path__ + "img/member_bottom02.cf91ba63.png";